import styled from 'styled-components'
export const Image = styled.img.attrs(
  (props: React.HTMLProps<HTMLImageElement>) => ({
    style: {
      ...props,
      ...props.style,
    },
  }),
)``
